/* eslint-disable no-shadow */
import { FormFields, FormValidationSchema } from '@/common/interfaces';

import type { SearchConsoleAnalytics } from '@/modules/DomainsApi';

export enum SiteGroupFormInputs {
  Name = 'name',
  SiteIds = 'siteIds',
}

export type SiteGroupFormFields = FormFields<typeof SiteGroupFormInputs>;

export type SiteGroupFormValidationSchema = FormValidationSchema<SiteGroupFormFields>;

export type SiteGroupSearchAnalyticsDomain = {
  id: string;
  name: string;
  siteId: string;
  siteName: string;
};

export type SiteGroupSearchAnalyticsSkippedDomain = Omit<SiteGroupSearchAnalyticsDomain, 'id' | 'name'> & {
  // null when the site lost all its domains after being added to the group
  id: string | null;
  name: string | null;
  reason: string;
};

export type SiteGroupSearchAnalytics = SearchConsoleAnalytics & {
  domains: {
    analysed: SiteGroupSearchAnalyticsDomain[];
    skipped: SiteGroupSearchAnalyticsSkippedDomain[];
  };
};
